import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useRecoilValue } from 'recoil';

import { NumberFormat } from '@ecp/common/src/utils/utils';
import { FlexBoxColumn } from '@ecp/common/src/layouts/flex/styled';
import { TextBox } from '@ecp/common/src/text/TextBox';

import { userInfoState } from '@mo-recoil/common/user/atom';
import { getIsLogin } from '@mo-recoil/common/user/selector';
import skypassMileageApi from '@mo-apis/price/skypassMileageApi';
import {
  Container,
  WelcomeText,
  InfoContainer,
  InfoTextBox,
  CloseButton,
  ShowMileageButton,
} from '@ecp/mo/sites/skypass/styles/navigation/SkypassNavigationUserInfoStyles';

export default function SkypassNavigationUserInfo() {
  const [isClose, setIsClose] = useState(false);
  const [showMileage, setShowMileage] = useState(false);
  const [mileageUsage, setMileageUsage] = useState(0);
  const userInfo = useRecoilValue(userInfoState);
  const isLogin = useRecoilValue(getIsLogin);
  const location = useLocation();

  useEffect(() => {
    setShowMileage(false);
  }, [location.pathname]);

  function close() {
    setIsClose(true);
  }

  async function onClickShowMileageButton() {
    await fetch();

    setShowMileage(true);
  }

  async function fetch() {
    if (isLogin) {
      const { result } = await skypassMileageApi.getMileage();

      const { currentMileage } = result;

      setMileageUsage(currentMileage);
    }
  }

  if (!isClose && isLogin) {
    return (
      <Container>
        <FlexBoxColumn gap={'14px'} width={'100%'}>
          <CloseButton onClick={close} />
          <WelcomeText>
            반갑습니다! <b style={{ fontWeight: 600 }}>{userInfo?.userName}</b> 님
          </WelcomeText>

          <InfoContainer>
            <InfoTextBox>
              <TextBox size={'12px'}>SKYPASS 회원번호</TextBox>
              <TextBox size={'16px'} style={{ fontWeight: 800 }}>
                {userInfo?.employNumber}
              </TextBox>
            </InfoTextBox>

            <InfoTextBox>
              <TextBox size={'12px'}>보유 마일리지</TextBox>

              {showMileage ? (
                <TextBox size={'12px'}>
                  <b style={{ fontWeight: 800, fontSize: '16px' }}>{NumberFormat(mileageUsage)}</b> 마일
                </TextBox>
              ) : (
                <ShowMileageButton onClick={onClickShowMileageButton}>조회하기</ShowMileageButton>
              )}
            </InfoTextBox>
          </InfoContainer>
        </FlexBoxColumn>
      </Container>
    );
  } else {
    return null;
  }
}
